// extracted by mini-css-extract-plugin
export default {"card":"card__OMC8yz_s","footerContainer":"footerContainer__goczyzJA","submitButton":"submitButton__NvksKJDN"};